import React, { useState, useEffect } from 'react';
import { useGroupDetailsContext } from '../context/group_context';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../utils/apiConfig';
import styled from 'styled-components';
import { useUserContext } from '../context/user_context';
import Popup from "../components/Popup";
import loadingImage from '../images/preloader.gif';
//for back button
import { useHistory } from 'react-router-dom';
import List from '../components/List';


const AvatarGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  &.rtl {
    direction: rtl;
    .avatar:hover:not(:last-of-type) {
      transform: translate(10px);    
    }
  }  
  @media (min-width: 992px) {
    flex-direction: row;
  }
   `;


const AddSub = () => {
  const history = useHistory();
  const { groupId } = useParams();
  const { isLoggedIn, user, isLoading, setIsLoading } = useUserContext();
  const [data, setData] = useState(null); //  
  const [avatars, setAvatars] = useState(null);
  const [noofSubscriber, setNoOfSubscriber] = useState(null);
  const [noofCompanySubscriber, setNoOfCompanySubscriber] = useState(null);
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);

  const { state: groupDetailsState, dispatch: groupDetailsDispatch } = useGroupDetailsContext();
  const [showList, setShowList] = useState(false);


  const fetchGroups = async () => {
    try {
      setIsLoading(true);
      const apiUrl = `${API_BASE_URL}/users/groups/${groupId}`;
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${user?.results?.token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch groups');
      }
      const fetchedData = await response.json();
      setData(fetchedData);


      // Dispatch an action to set the data in the context
      groupDetailsDispatch({ type: 'SET_DATA', payload: fetchedData });
      console.log('*******mani-Fetched Data****************')
      console.log(fetchedData);
      console.log(fetchedData.results.groupSubcriberResult);
      setList(fetchedData?.results?.groupSubcriberResult);

      console.log('***********Fetched Data************');

    } catch (error) {
      console.error('Error fetching groups:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, [groupId, setIsLoading, groupDetailsDispatch]); // Fetch data whenever the groupId changes




  const fetchSubscribers = async () => {
    try {
      setIsLoading(true);
      const apiUrl = `${API_BASE_URL}/groups/${groupId}/subscribers`;
  
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${user?.results?.token}`,
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch subscribers');
      }
  
      const data = await response.json();
      setAvatars(data?.results?.subscriberList);
      console.log('To check images');
      console.log(data?.results?.subscriberList);
      setNoOfSubscriber(data?.results?.subscriberCountList[0]?.No_of_Sub_Pending);
      setNoOfCompanySubscriber(data?.results?.compSubCountList[0]?.no_of_company_subcribers);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchSubscribers();
  }, [groupId,setIsLoading]);
  

 
  const handleBackButtonClick = () => {
    history.goBack();
  };
  // Function to toggle the showList state
  const toggleList = () => {
    setShowList(!showList);
  };

  const removeItem = (id) => {
    deleteGroupSubscriber(id);
  };

  const deleteGroupSubscriber = async (id) => {

    const apiUrl = `${API_BASE_URL}/groupsubscribers/${id}`;

    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${user?.results?.token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {


        // showAlert(true, 'danger', 'item removed');
        setList(list.filter((item) => item.id !== id));

        await fetchGroups(); // Refresh the entire details of group.
        await fetchSubscribers();
      } else {
        const errorResponse = await response.json();
        //showAlert(true, 'danger', errorResponse.message);
      }
    } catch (error) {
      console.error('An error occurred while deleting the group subscriber:', error);
      //showAlert(true, 'danger', 'An error occurred while deleting the group subscriber');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <>
        <img src={loadingImage} className="loading-img" alt="loading" />
        <div className="placeholder" style={{ height: '50vh' }}></div>
      </>
    );
  }

  return (
    <Wrapper>
      <div className="section-center">
        <div className="header">
          <h3>Add {noofSubscriber} Subscribers.</h3>
          <button onClick={handleBackButtonClick}>Back</button>
          <button onClick={toggleList}>
            View Added Subscribers
          </button>
        </div>

        <div className="content">
          <AvatarGroupContainer className="avatar-group">
            {avatars === null ? (
              <div className="hidden-avatars">+</div>
            ) : (
              <div className="hidden-avatars-container">
                <div className="hidden-avatars" onClick={() => setOpen(true)}>
                  {noofSubscriber} +
                </div>
                <div className="hidden-avatar-label">Add</div>
              </div>
            )}
            {avatars &&
              avatars.map((avatar, index) => (
                <div className="avatars-container" key={index}>
                  <div className="avatar">
                    <img
                      src={avatar.user_image_from_s3 || "default-image.jpg"}
                      alt={avatar.name}
                      onError={(e) => { e.target.src = "default-image.jpg"; }}
                    />


                  </div>
                  <div className="avatar-label">{avatar.name}</div>
                </div>
              ))}
          </AvatarGroupContainer>
        </div>
      </div>
      {open ? <Popup closePopup={() => setOpen(false)} groupId={groupId} noofCompanySubscriber={noofCompanySubscriber} noofSubscriber={noofSubscriber} /> : null}

      {list?.length > 0 && (
        <div className="subcriber-container">

          {showList && (
            <div className="list-modal">
              <button className="close-list-btn" onClick={toggleList}>
                X
              </button>
              <List items={list} removeItem={removeItem}  />
            </div>
          )}
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 1rem 0;
  h3 {
    text-transform: none;
  }  
  display: flex;
  &.rtl {
    direction: rtl;
    .avatar:hover:not(:last-of-type) {
      transform: translate(10px);    
    }
  }
  .hidden-avatars-container{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }  
  .hidden-avatars {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 3px;
    margin-right: 23px;
    background-color: #cd3240;
    color: #fff;
  }
  .hidden-avatars:hover {
    cursor: pointer;
  }
  .hidden-avatar-label{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 3px;
    margin-right: 23px;
  }
  .avatar-group{
    flex-wrap: wrap;
  }
  .avatars-container
  {
    display: flex;
    
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .avatar {
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 70%;
    position: relative;
    background-color: #2c303a;
    border: 2px solid #2c303a;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    margin-left: -20px;
    transition: transform 0.3s ease;
    cursor: pointer;
    &:hover:not(:last-of-type) {
      transform: translate(-20px);
    }     
    .avatar-label{
      display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 3px;
    margin-right: 23px;
    } 
       
  } 
  button {
    background-color: var(--clr-primary-1);
    color: var(--clr-white);
    padding: 0.5rem 1rem;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    width: 100%; /* Set a fixed width */
    box-sizing: border-box; /* Include padding and border in the width calculation */
    margin-bottom: 3.5rem;
    margin-top: 1rem;
  }
    

 
  @media (min-width: 992px) {
    .content {
      display: grid;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      margin-top: 1rem;
      margin-bottom: 8rem;
    }
    
   
  }
  @media (min-width: 1280px) {
    padding: 5rem 0;
  }
  .header {
    display: grid;
    grid-template-columns: 1fr 1fr auto; /* Updated grid template columns */
    align-items: center;    
    margin-bottom: 1rem;
    grid-gap: 0.5rem;
  }
     .list-modal {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 600px;
      height: 600px;
      background: var(--clr-white);
      border-radius: var(--radius);
      box-shadow: var(--light-shadow);
      overflow-y: scroll;
      padding: 1rem;
      z-index: 1000; /* Ensure it appears above other elements */
      @media (max-width: 768px) {
        width: 90%; /* Adjust the width for screens with a max-width of 768px */
        height: 90vh; /* Adjust the height for smaller screens */
        padding: 0.5rem; /* Reduce padding for smaller screens */
      }
    
      @media (max-width: 480px) {
        width: 95%; /* Further adjust the width for screens with a max-width of 480px */
        height: 85vh; /* Further adjust the height for smaller screens */
        padding: 0.25rem; /* Reduce padding for smaller screens */
      }
    }
       .subcriber-container {      
      margin-top: o.5rem;
    }
    .subcriber-item {
      margin-top:12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5rem;
      transition: var(--transition);
      padding: 0.25rem 1rem;
      border-radius: var(--radius);
      text-transform: capitalize;
      img {
        height: 100%;
        width: 45px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    
    .subcriber-item:hover {
      color: var(--clr-grey-5);
      background: var(--clr-grey-10);
    }
    
    .subcriber-item:hover .title {
      color: var(--clr-grey-5);
    }
      .subcriber-header {
    
    background-color: #cd3240;
    color: #fff;
    display: flex;
    padding:4px 16px;
    align-items: center; /* Vertical alignment */
    justify-content: center; /* Horizontal alignment */
    justify-content: space-between;     
}
.subcriber-header p {
  
  color: #fff;
  align-items: center; /* Vertical alignment */
    justify-content: center; /* Horizontal alignment */
}
    .title {
      margin-bottom: 0;
      color: var(--clr-grey-1);
      letter-spacing: 2px;
      transition: var(--transition);
    }
    
    .edit-btn,
    .delete-btn {
      background: transparent;
      border-color: transparent;
      cursor: pointer;
      font-size: 0.7rem;
      margin: 0 0.15rem;
      transition: var(--transition);
    }
    
    .edit-btn {
      color: var(--clr-green-light);
    }
    
    .edit-btn:hover {
      color: var(--clr-green-dark);
    }
    
    .delete-btn {
      color: var(--clr-red-light);
    }
    
    .delete-btn:hover {
      color: var(--clr-red-dark);
    }
    
    .clear-btn {
      text-transform: capitalize;
      width: 10rem;
      height: 1.5rem;
      display: grid;
      align-items: center;
      background: transparent;
      border-color: transparent;
      color: var(--clr-red-light);
      margin: 0 auto;
      font-size: 0.85rem;
      letter-spacing: var(--spacing);
      cursor: pointer;
      transition: var(--transition);
      margin-top: 1.25rem;
    }
    
    .clear-btn:hover {
      color: var(--clr-red-dark);
    }
`

export default AddSub;
